import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getEventBySlug, events } from '../data/events';
import { PageBanner } from '../components/PageBanner';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { KeyDetailsBlock } from '../components/KeyDetailsBlock';
import { ImageGallery } from '../components/ImageGallery';
import { RelatedPages } from '../components/RelatedPages';
import { EnquiryForm } from '../components/EnquiryForm';
export function EventDetail() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const event = slug ? getEventBySlug(slug) : undefined;
  if (!event) return <Navigate to="/events" replace data-id="element-782" />;
  const otherEvents = events.filter(e => e.id !== event.id).slice(0, 3).map(e => ({
    title: e.title,
    image: e.image,
    link: `/events/${e.id}`
  }));
  return <div className="w-full bg-club-canvas pb-24" data-id="element-783">
      <PageBanner title={event.title} eyebrow="Club Event" image={event.image} data-id="element-784" />

      <div className="max-w-7xl mx-auto px-4 mt-8" data-id="element-785">
        <Breadcrumbs items={[{
        label: 'Events Calendar',
        path: '/events'
      }, {
        label: event.title
      }]} data-id="element-786" />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mt-8" data-id="element-787">
          <div className="lg:col-span-2 space-y-12" data-id="element-788">
            <section data-id="element-789">
              <h2 className="text-3xl mb-6" data-id="element-790">Event Details</h2>
              <p className="text-lg text-club-ink/80 leading-relaxed" data-id="element-791">
                {event.longDesc}
              </p>
            </section>

            {event.images && event.images.length > 1 && <section data-id="element-792">
                <h2 className="text-3xl mb-6" data-id="element-793">Gallery</h2>
                <ImageGallery images={event.images} data-id="element-794" />
              </section>}

            <section id="rsvp" data-id="element-795">
              <EnquiryForm variant="event" title="RSVP to Event" data-id="element-796" />
            </section>
          </div>

          <div className="space-y-8" data-id="element-797">
            <KeyDetailsBlock details={event.keyDetails} data-id="element-798" />

            <div className="bg-club-green text-white p-8 rounded-sm text-center" data-id="element-799">
              <h3 className="font-serif text-2xl mb-4" data-id="element-800">Reserve Your Spot</h3>
              <p className="text-sm text-white/80 mb-6" data-id="element-801">
                Spaces are limited for this exclusive event. Please RSVP early
                to avoid disappointment.
              </p>
              <a href="#rsvp" className="btn-gold w-full block" data-id="element-802">
                RSVP Now
              </a>
            </div>
          </div>
        </div>

        <RelatedPages title="Upcoming Events" pages={otherEvents} data-id="element-803" />
      </div>
    </div>;
}